const success = (message) => {
  const toast = document.createElement('div');
  toast.classList.add('toast');
  toast.innerHTML = message;
  document.body.appendChild(toast);
  setTimeout(() => {
    toast.classList.add('toast-enter');
  }, 100);
  setTimeout(() => {
    toast.classList.remove('toast-enter');
  }, 3000);
  setTimeout(() => {
    toast.remove();
  }, 4000);
};

export const toast = {
  success,
};
